module.exports = __webpack_public_path__ + "img/D0013.962d1d14.svg";